import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { CurrencyField } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { isNotBlank } from '@roc/feature-utils';

interface PropertyTaxesFormContentProps {
  open: boolean;
}

export const PropertyTaxesEditModal = observer(({ open }: PropertyTaxesFormContentProps) => {
  const { docReviewStoreV2 } = useStore();
  const { propertyTaxesFormStore } = docReviewStoreV2;

  useEffect(() => {
    if (open) propertyTaxesFormStore.load(docReviewStoreV2.docReviewData);
  }, [open]);

  const handleChange = (field: string, value: any) => {
    propertyTaxesFormStore.onFieldChange(field, value);
  };

  const f = propertyTaxesFormStore.form.fields;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CurrencyField
          label="Annual Tax Amount"
          value={f.annualTaxAmount.value}
          onChange={(_name, value) => handleChange('annualTaxAmount', value)}
          name="annualTaxAmount"
          testId="annualTaxAmount"
          variant="outlined"
          fullWidth
          standaloneLabel
          required
          error={isNotBlank(f.annualTaxAmount.error)}
          errorText={f.annualTaxAmount.error}
        />
      </Grid>
    </Grid>
  );
});
